import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import * as React from 'react';
// @mui
import { Container, Stack, Button, Checkbox, Autocomplete, TextField, Grid } from '@mui/material';
// Tabela
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

import AddMensagem from './AddMensagem';

// api
import { getFluxogramas, updateMensagem } from './api';
import { status } from './apiWpp';

// ----------------------------

const emptyData = {
  enviamensagem: '',
  mensagem: '',
  destino: [],
};

// ----------------------------------------------------------------------

export default function Mensagens() {
  const [fluxogramas, setFluxogramas] = useState([]);
  const [fluxoSelecionado, setFluxoSelecionado] = useState('');

  useEffect(() => {
    fetchFluxos();
  }, []);

  const fetchFluxos = () => {
    getFluxogramas()
      .then((dados) => {
        setFluxogramas(dados);
      })
      .catch((error) => {
        // Trate erros aqui
        window.alert('Erro ao consultar banco de dados');
        console.error('Erro ao buscar dados da API:', error);
      });
  };

  // Modal
  const [open, setOpen] = React.useState(false);
  const [data, setData] = React.useState({ ...emptyData });
  const [statusWpp, setStatusWpp] = useState(null);
  const [statusConexao, setStatusConexao] = useState('Verificar Conexão Whatsapp');

  const handleClose = () => {
    setOpen(false);
    setData(emptyData);
  };

  const onConfirmHandler = async (data) => {
    const result = await updateMensagem(fluxoSelecionado, data);
    if (result.ok) {
      handleClose();
      fetchFluxos();
    }
    window.alert(result.msg);
  };

  // Tabela
  const handleDoubleClickTable = (row, index) => {
    setData({ ...row, index });
    setOpen(true);
  };

  let cont = 0;
  const testConnectionWP = async () => {
    setStatusConexao('Verificando');
    const resultado = await status();
    setStatusWpp(resultado);
    if (!resultado.ok) {
      window.alert('Erro ao tentar conectar');
      setStatusConexao('Verificar Conexão Whatsapp');
      return;
    }
    if (!resultado.connected && cont <= 10) {
      setStatusConexao(`Leia o QRCode (${cont})`);
      cont += 1;
      await sleep(3000);
      testConnectionWP();
      return;
    }
    if (cont > 10) {
      setStatusWpp(null);
      cont = 0;
      window.alert('Tempo de Conexão Expirado');
      setStatusConexao('Verificar Conexão Whatsapp');
    }
  };
  function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  // ----------------------

  return (
    <>
      <Helmet>
        <title> Mensagens </title>
      </Helmet>

      <Container maxWidth="xl">
        <Stack direction={'row'} justifyContent={'space-between'}>
          {/* Conexao com whatsapp */}
          <Stack className="notranslate" sx={{ height: '80vh', justifyContent: 'center', alignItems: 'center' }}>
            {statusWpp?.qrcode !== null && !statusWpp?.connected ? <img src={statusWpp?.qrcode} alt="" /> : null}
            {<br />}
            {statusWpp?.connected ? (
              <Button variant="contained" color="success">
                Whatsapp Conectado
              </Button>
            ) : (
              <Button variant="contained" onClick={testConnectionWP}>
                {statusConexao}
              </Button>
            )}
          </Stack>
          {/* Fluxo e mensagens */}
          <Stack sx={{ border: 1, borderRadius: 2, borderColor: 'LightBlue' }}>
            <Autocomplete
              disablePortal
              id="fluxo"
              value={fluxoSelecionado || null}
              onChange={(event, newValue) => {
                setFluxoSelecionado(newValue);
              }}
              options={fluxogramas}
              isOptionEqualToValue={(option, value) => option.id === value.id}
              getOptionLabel={(option) => `${option.nome}`}
              sx={{ p: 3 }}
              renderInput={(params) => <TextField {...params} label="Selecione o Fluxo" />}
            />

            {/* ------------ Tabela de Kits ------------ */}
            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell align="left">Nome</TableCell>
                    <TableCell align="center">Mensagem Interna</TableCell>
                    <TableCell align="center">Mensagem Cliente</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {fluxogramas
                    ?.find((value) => value._id === fluxoSelecionado?._id)
                    ?.etapas?.map((row, index) => (
                      <TableRow
                        key={index}
                        sx={{
                          '&:last-child td, &:last-child th': { border: 0 },
                          '&:hover': { backgroundColor: 'Azure' },
                        }}
                        onDoubleClick={() => handleDoubleClickTable(row, index)}
                      >
                        <TableCell align="left" sx={{ whiteSpace: 'nowrap' }}>
                          {row.nome}
                        </TableCell>
                        <TableCell align="center">
                          <Checkbox id="enviamensagem" disabled checked={row.enviamensagem || ''} />
                        </TableCell>
                        <TableCell align="center">
                          <Checkbox id="enviamensagem" disabled checked={row.enviaMensagemCliente || ''} />
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Stack>
        </Stack>

        {/* Modal Add */}
        <AddMensagem open={open} data={data} onClose={handleClose} onConfirm={onConfirmHandler} />
      </Container>
    </>
  );
}
